export default function KeyFactorsPanel({ context, sport }) {
  if (!context) {
    return (
      <div className="rounded border border-[#E5E7EB] dark:border-[#1e2536] bg-white dark:bg-[#151a25] px-5 py-4">
        <SectionHeader>Key Factors</SectionHeader>
        <p className="text-[#6B7280] dark:text-[#8892a8] text-[11px] mt-2">Context data unavailable.</p>
      </div>
    );
  }

  const hasWeather = !!context.weather;

  return (
    <div className="rounded border border-[#E5E7EB] dark:border-[#1e2536] bg-white dark:bg-[#151a25] px-5 py-4">
      <SectionHeader>Key Factors</SectionHeader>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-3">
        {/* Records */}
        <div className="rounded border border-[#E5E7EB] dark:border-[#1e2536] bg-[#F8F9FA] dark:bg-[#0f1219] p-3">
          <h4 className="text-[12px] uppercase tracking-[1px] font-medium text-[#005BB3] dark:text-[#3b82f6] mb-2" style={{ fontFamily: 'var(--font-sans)' }}>Records</h4>
          {context.home_record || context.away_record ? (
            <div className="space-y-1.5">
              {context.away_team && <RecordRow team={context.away_team} record={context.away_record} />}
              {context.home_team && <RecordRow team={context.home_team} record={context.home_record} />}
            </div>
          ) : <p className="text-[#6B7280] dark:text-[#8892a8] text-[11px]">No data.</p>}
        </div>

        {/* Injuries */}
        <div className="rounded border border-[#E5E7EB] dark:border-[#1e2536] bg-[#F8F9FA] dark:bg-[#0f1219] p-3">
          <h4 className="text-[12px] uppercase tracking-[1px] font-medium text-[#005BB3] dark:text-[#3b82f6] mb-2" style={{ fontFamily: 'var(--font-sans)' }}>Injuries</h4>
          {context.injuries?.length > 0 ? (
            <div className="space-y-1.5">
              {context.injuries.map((inj, i) => (
                <div key={i}>
                  <div className="flex items-center gap-1.5">
                    <StatusBadge status={inj.status} />
                    <span className="text-[12px] font-medium text-[#111827] dark:text-[#e2e8f0]">{inj.player}</span>
                    <span className="text-[10px] text-[#6B7280]">{inj.position}</span>
                  </div>
                  <p className="text-[10px] text-[#6B7280] dark:text-[#8892a8] ml-10">{inj.detail}</p>
                </div>
              ))}
            </div>
          ) : <p className="text-[#6B7280] dark:text-[#8892a8] text-[11px]">None reported.</p>}
        </div>

        {/* Weather / Venue */}
        <div className="rounded border border-[#E5E7EB] dark:border-[#1e2536] bg-[#F8F9FA] dark:bg-[#0f1219] p-3">
          <h4 className="text-[12px] uppercase tracking-[1px] font-medium text-[#005BB3] dark:text-[#3b82f6] mb-2" style={{ fontFamily: 'var(--font-sans)' }}>{hasWeather ? 'Weather' : 'Venue'}</h4>
          {hasWeather ? (
            <div className="space-y-1">
              <p className="text-[11px] text-[#1F2937] dark:text-[#8892a8]">{context.weather.venue}</p>
              <div className="flex items-baseline gap-2">
                <span className="text-xl font-bold text-[#111827] dark:text-[#e2e8f0]" style={{ fontFamily: 'var(--font-mono)' }}>{context.weather.temp_f}&deg;F</span>
                <span className="text-[11px] text-[#6B7280]">{context.weather.condition}</span>
              </div>
              <p className="text-[10px] text-[#6B7280] dark:text-[#8892a8]" style={{ fontFamily: 'var(--font-mono)' }}>Wind: {context.weather.wind_mph} mph {context.weather.wind_dir}</p>
            </div>
          ) : <p className="text-[#6B7280] dark:text-[#8892a8] text-[11px]">Indoor or unavailable.</p>}
        </div>
      </div>
    </div>
  );
}

function SectionHeader({ children }) {
  return (
    <div className="flex items-center gap-2">
      <div className="w-[3px] h-4 bg-[#005BB3] rounded-full" />
      <h3 className="text-[12px] uppercase tracking-[1px] font-medium text-[#005BB3] dark:text-[#3b82f6]" style={{ fontFamily: 'var(--font-sans)' }}>{children}</h3>
    </div>
  );
}

function RecordRow({ team, record }) {
  return (
    <div className="flex justify-between text-[11px]">
      <span className="text-[#1F2937] dark:text-[#8892a8]">{team}</span>
      <span className="font-semibold text-[#111827] dark:text-[#e2e8f0]" style={{ fontFamily: 'var(--font-mono)' }}>{record || '—'}</span>
    </div>
  );
}

function StatusBadge({ status }) {
  const colors = {
    Out: 'bg-[#FEF0F0] text-[#DC2626] dark:bg-[rgba(239,68,68,0.1)] dark:text-[#ef4444]',
    Questionable: 'bg-[rgba(234,179,8,0.1)] text-[#eab308]',
    Probable: 'bg-[rgba(16,185,129,0.1)] text-[#10b981]',
    Doubtful: 'bg-[rgba(249,115,22,0.1)] text-[#f97316]',
  };
  return <span className={`text-[9px] font-semibold px-1 py-px rounded ${colors[status] || 'bg-[#1a2030] text-[#6B7280]'}`}>{status}</span>;
}
